export default "__VITE_ASSET__zjr2DPtA__"